
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/startups/[startupId]",
      function () {
        return require("private-next-pages/startups/[startupId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/startups/[startupId]"])
      });
    }
  